import { eachDayOfInterval, endOfWeek, format, startOfWeek } from 'date-fns';
import { useConfig } from '../../../../../context/ConfigProvider/ConfigProvider';
export const useGetShortWeekDays = () => {
    const { dateFnsLocale } = useConfig();
    const nowDate = new Date();
    const startOfWeekDate = startOfWeek(nowDate, { locale: dateFnsLocale });
    const endOfWeekDate = endOfWeek(nowDate, { locale: dateFnsLocale });
    const shortWeekDays = eachDayOfInterval({
        start: startOfWeekDate,
        end: endOfWeekDate,
    });
    const formattedShortWeekDays = shortWeekDays.map((day) => format(day, 'EEEEEE', { locale: dateFnsLocale }));
    return formattedShortWeekDays;
};
